import React from 'react'
import { Popover, Table } from 'antd'
// import { usePagination } from 'modules/core/customHooks'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import _ from 'lodash'
import Typography from '../Typography/Typography'
import { EyeOutlined } from '@ant-design/icons'
import PropTypes from 'prop-types'

const ActivityTrackingDetail = ({ dataSource, loading, tablePagination, setTablePagination }) => {
  // const [tablePagination, setTablePagination] = usePagination()
  const { t } = useTranslation()

  const columnsDetail = (data) => {
    if (data.row) {
      const dimCol = _.map(data.row, (d, k) => {
        return {
          title: k,
          dataIndex: k,
          width: 100,
          render: (v, r) => r.row[k],
        }
      })

      const cols = [
        ...dimCol,
        {
          title: t('FIELD_PREVIOUS_AMOUNT'),
          dataIndex: 'total_before',
          render: (val) => `$${val}`,
        },
        {
          title: t('FIELD_MODIFIED_AMOUNT'),
          dataIndex: 'amount',
          render: (val) => `$${val}`,
        },
        {
          title: t('LABEL_BUDGET_TYPE'),
          dataIndex: 'concept',
        },
        {
          title: t('FIELD_PHASE'),
          dataIndex: 'step',
        },
        {
          title: t('FIELD_CHANGE_MADE'),
          dataIndex: 'type_change',
        },
      ]

      return cols
    } else if (!data.row && (data.amount || data.price || data.quantity)) {
      const { amount, currency_id, planning_id, price, quantity, step, ...restProps } = data

      const dimCol = _.map(restProps, (d, k) => {
        console.log(d, k)
        return {
          title: k,
          dataIndex: k,
          width: 100,
          render: () => d,
        }
      })

      const cols = [
        ...dimCol,
        {
          title: t('FIELD_PERCENTAGE_AMOUNT_MODIFIED'),
          dataIndex: 'amount',
          render: (val) => `${val}%`,
        },
        {
          title: t('FIELD_PERCENTAGE_PRICE_MODIFIED'),
          dataIndex: 'price',
          render: (val) => `${val}%`,
        },
        {
          title: t('FIELD_PERCENTAGE_QUANTITY_MODIFIED'),
          dataIndex: 'quantity',
          render: (val) => `${val}%`,
        },
        {
          title: t('FIELD_PHASE'),
          dataIndex: 'step',
        },
      ]

      return cols
    } else {
      const cols = [
        {
          title: t('FIELD_DIMENSION'),
          dataIndex: 'dimension',
        },
        {
          title: t('FIELD_PREVIOUS_VALUE'),
          dataIndex: 'old_value',
        },
        {
          title: t('FIELD_NEW_VALUE'),
          dataIndex: 'new_value',
        },
      ]

      return cols
    }
  }

  const renderDataSource = (data) => {
    if (data.row) {
      return [data]
    } else if (!data.row && (data.amount || data.price || data.quantity)) {
      return [data]
    } else {
      const dim = _.keys(data)

      const dataTable = dim.map((el) => {
        return {
          dimension: el,
          ...data[el],
        }
      })

      return dataTable
    }
  }

  const renderContent = (data) => {
    return (
      <div style={{ width: '100%' }}>
        <Table
          rowKey="id"
          bordered
          size="small"
          columns={columnsDetail(data)}
          dataSource={renderDataSource(data)}
          pagination={false}
        />
      </div>
    )
  }

  const columns = [
    {
      title: t('FIELD_DATE'),
      dataIndex: 'created_at',
      render: (value) =>
        `${moment(value).format('DD/MM/YYYY')} ${t('DATE_AT_TIME')} ${moment(value).format(
          'HH:mm',
        )}`,
    },
    {
      title: t('LABEL_USER'),
      dataIndex: 'user',
    },
    {
      title: t('FIELD_DESCRIPTION'),
      dataIndex: 'message',
    },
    {
      title: t('FIELD_ACTIONS'),
      dataIndex: 'detail',
      align: 'right',
      render: (detail) => {
        if (!_.isEmpty(detail)) {
          return (
            <Popover trigger="click" placement="left" content={renderContent(detail)}>
              <Typography.Icon icon={EyeOutlined} />
            </Popover>
          )
        }
      },
    },
  ]

  return (
    <Table
      rowKey="id"
      bordered
      size="small"
      loading={loading}
      onChange={setTablePagination}
      columns={columns}
      dataSource={dataSource.values}
      pagination={{
        pageSize: tablePagination.page_size,
        current: tablePagination.page,
        total: dataSource.count,
        pageSizeOptions: ['10', '20', '30'],
        showSizeChanger: true,
        size: 'small',
      }}
    />
  )
}

ActivityTrackingDetail.propTypes = {
  dataSource: PropTypes.shape({
    values: PropTypes.array,
    count: PropTypes.number,
  }),
  loading: PropTypes.bool,
  tablePagination: PropTypes.shape({
    page_size: PropTypes.number,
    page: PropTypes.number,
  }),
  setTablePagination: PropTypes.func,
}

export default ActivityTrackingDetail
